import {
	type CustomField,
	type SaveCustomFieldRequest,
	apiAppBusinessCustomfieldUpsertactivity,
	apiAppBusinessCustomfieldDeleteactivity
} from '#lib/types/generated/index.js';
import { optimisticDelete, optimisticSave } from '#lib/stores/optimistic.js';
import { writable } from 'svelte/store';

export const customFieldStore = writable<CustomField[]>([]);
export const customFieldFormContext = writable<{
	attachToCustomer: boolean;
}>({ attachToCustomer: false });

export function toSaveCustomFieldRequest(customField: CustomField): SaveCustomFieldRequest {
	return {
		shortName: customField.shortName,
		icon: customField.icon,
		appRule: customField.appRule,
		widgetRule: customField.widgetRule,
		visibleByCustomer: customField.visibleByCustomer,
		attachToCustomer: customField.attachToCustomer,
		displayInBookingList: customField.displayInBookingList,
		displayInBookingPreview: customField.displayInBookingPreview,
		displayOnSession: customField.displayOnSession,
		sortOrder: customField.sortOrder,
		applyOnAllBookings: customField.applyOnAllBookings,
		fieldType: customField.fieldType,
		applyOnActivities: customField.applyOnActivities,
		applyOnOffers: customField.applyOnOffers,
		applyOnSessions: customField.applyOnSessions,
		fieldSettings: customField.fieldSettings,
		publicName: customField.publicName,
		publicDescription: customField.publicDescription,
		applyMinPax: customField.applyMinPax,
		applyMaxPax: customField.applyMaxPax
	};
}

export function saveCustomField(customField: CustomField): Promise<CustomField> {
	return optimisticSave(customFieldStore, customField, () =>
		apiAppBusinessCustomfieldUpsertactivity(
			customField.id,
			toSaveCustomFieldRequest(customField)
		)
	);
}

export async function deleteCustomField(customField: CustomField): Promise<void> {
	await optimisticDelete(customFieldStore, customField, () =>
		apiAppBusinessCustomfieldDeleteactivity(customField.id)
	);
}
